import styled from '@emotion/styled';
import { Container } from '@mui/material';
import React from 'react'
import DesktopMenu from './component/DesktopMenu';
import MobileMenu from './component/MobileMenu';

const Div = styled.div`
`

const LockerMenu = (props) => {
    const menuList = [ // You can pass 4 perameters for menu title, link, target and customClass
        {
        title: "Buy $SINU",
        link: "/#",
        },
        {
        title: "About",
        link: "/#about",
        },
        {
        title: "Tokenomics",
        link: "/#tokenomics",
        },
        {
        title: "How to buy",
        link: "/#howtobuy",
        },
        {
        title: "FAQ",
        link: "/#faq",
        },
        {
        title: "Join Telegram",
        link: "https://t.me/sanshuinuportal",
        customClass: "customclass",
        },
    ];
  return (
    <Div>
    <Container maxWidth="xl">
        <DesktopMenu menuList={menuList} />
        <MobileMenu menuList={menuList} />
    </Container>
    </Div>
  )
}

export default LockerMenu